<template>
    <ValidationProvider :name="name" :rules="field._validation" v-slot="validator">
        <!--<b-field>-->
        <b-checkbox class="checkbox-container" v-model="value"
                    :true-value="field._true_value"
                    :false-value="field._false_value">

            <component v-if="checkIsVueComponent(field._label)" :is="generateVueComponent(field._label)"></component>
            <span v-else v-html="field._label  + (validator.required ? ' *': '' )"
                  :class="validator.failed ? 'label_error' : ''"></span>
        </b-checkbox>
        <!--</b-field>-->
        <EvoError v-if="validator.errors[0]" :validator="validator"></EvoError>
    </ValidationProvider>
</template>

<script>
import mixin from "./mixin";
import Vue from 'vue'

export default {
    mixins: [mixin],
    methods: {
        generateVueComponent(component) {
            return component;
        },
        checkIsVueComponent(component) {
            return !_.isString(component)
        }
    },
}
</script>
